var map = {
	"./assets-hhl/img/wapdownload/az_quanqiugou_logo.png": "f718",
	"./assets-mc/img/wapdownload/az_quanqiugou_logo.png": "3873",
	"./img/wapdownload/az_quanqiugou_logo.png": "c33b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0cda";